module.exports = __webpack_public_path__ + "images/tomato_web-d883c82505e2d0c079f57fb5fd674d38.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/tomato_web.svg
// module id = 213
// module chunks = 0